import React, { useState } from "react";
import styles from "./header.module.css";
import { experts } from "../../data";
import { getRandomInt } from "../../../../util";

const Header = () => {
  const [randomExperts] = useState(
    [...experts].sort(() => 0.5 - Math.random()).slice(0, 3)
  );

  const [expertsOnline] = useState(getRandomInt(15, 20));

  return (
    <div className={styles.header}>
      <h3 className={styles.title}>
        Get matched with the Best Astrologers, Guaranteed. Get the certainty you
        want.
      </h3>
      <div className={styles.header_flex}>
        <div className={styles.images_flex}>
          {randomExperts.map((expert, idx) => (
            <img
              src={expert.avatar}
              className={styles.image}
              alt={expert.name}
            />
          ))}
        </div>
        <p className={styles.text}>
          {expertsOnline} verified experts are online now.
        </p>
      </div>
    </div>
  );
};

export { Header };
